import React, { useEffect, useRef, useState } from "react";
import UserCard from "../components/layout/UserCard";
import { getUser } from "../api/getUser";
import UserAchivments from "../components/layout/UserAchivments";
import Roadmap from "../components/layout/Roadmap";
import { httpReauest } from "../utils/httpRequest";
import { toPng } from "html-to-image";
import EventTimerCard from "../components/common/cards/EventTimerCard";
import { FaTimes } from "react-icons/fa";

const HomePage = () => {
  const [data, setdata] = useState();
  const [loading, setloading] = useState(false);
  const [error, seterror] = useState();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [event, setEvent] = useState(null);
  const [previousData, setpreviousData] = useState(null);
  const [showEligible, setShowEligible] = useState(true);
  const [countdown, setCountdown] = useState(""); // برای نمایش زمان باقی‌مانده
  const timerRef = useRef(null);
  useEffect(() => {
    getData();
    getEvent();
    getPrevoisPhase();
  }, []);

  useEffect(() => {
    const deadlineUTC = new Date(Date.UTC(2025, 6, 27, 0, 0, 0)); // 2025-07-27 00:00:00 UTC

    const updateCountdown = () => {
      const now = new Date();
      const diff = deadlineUTC - now;

      if (diff <= 0) {
        setShowEligible(false);
        if (timerRef.current) clearInterval(timerRef.current); // 👈 حالا اینجا مشکلی نیست
        return;
      }

      const hours = Math.floor(diff / (1000 * 60 * 60));
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((diff % (1000 * 60)) / 1000);

      setCountdown(
        `${hours.toString().padStart(2, "0")}:${minutes
          .toString()
          .padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`
      );
    };

    updateCountdown(); // اولین بار فوراً اجراش کن

    timerRef.current = setInterval(updateCountdown, 1000); // 👈 مقداردهی درست به useRef

    return () => clearInterval(timerRef.current); // پاک‌سازی در خروج
  }, []);

  async function getData() {
    const user = JSON.parse(localStorage.getItem("user"));
    if (!user) return;
    const res = await getUser(user._id);
    setdata(res);
  }

  async function getEvent() {
    const res = await httpReauest("GET", "/user/event");
    setEvent(res.data?.data);
  }

  async function getPrevoisPhase() {
    const user = JSON.parse(localStorage.getItem("user"));
    const res = await httpReauest("GET", `/user/${user?._id}/phase/phase1`);
    console.log(res);
    setpreviousData(res.data?.data);
  }

  async function handleClaimNFT() {
    setloading(true);
    await httpReauest("POST", "/user/claim-nft", {}, {})
      .then(async (res) => {
        await getData();
      })
      .catch(() => seterror(true));
    setloading(false);
  }

  const formatDate = (date) => {
    if (!(date instanceof Date) || isNaN(date))
      throw new Error("Invalid date provided");
    const day = date.getDate();
    const month = date
      .toLocaleString("default", { month: "short" })
      .toUpperCase();
    const year = date.getFullYear();
    return `${day} ${month}, ${year}`;
  };

  console.log(previousData)

  return (
    <div className="w-full py-6 text-white">
      {event?.end_time && <EventTimerCard event={event} user={data} />}

      {previousData && (
        <div className="rounded-[16px] bg-[#225381] p-6 items-center relative shadow shadow-white/40 border border-white/10 mb-5">
          <div className="space-y-4">
            <p className="text-lg font-medium">
              🎉Thank you for your outstanding contribution to the FileTrust
              Campaign. Your personal performance summary is now available.
            </p>
            <button
              onClick={() => {
                setIsModalOpen(true);
              }}
              className={`mt-4 px-6 py-2 disabled:bg-slate-500 disabled:opacity-80 bg-indigo-500 hover:bg-indigo-600 transition-colors rounded-xl text-white font-semibold shadow-lg`}
            >
              See Stats
            </button>
          </div>
          {isModalOpen && (
            <div className="fixed inset-0 bg-black bg-opacity-60 flex justify-center items-center z-50 ">
              <div className="bg-[#1e293b] rounded-xl max-w-[370px] sm:max-w-[560px] w-full p-4 text-white relative max-h-[90vh] overflow-auto">
                <button
                  onClick={() => {
                    setIsModalOpen(false);
                  }}
                  className="absolute right-3 top-3 text-white"
                >
                  <FaTimes />
                </button>
                <h2 className="text-xl font-bold mb-3">
                  Your Stats in FileTrust Campaign phase 1
                </h2>
                <div className="bg-[#111827] border border-white/10 rounded-lg p-1 mb-4 text-center">
                  <>
                    <div className="rounded-[16px] bg-[#0E171D] p-2 gap-2 flex flex-row flex-wrap w-full justify-between items-center relative max-w-[370px] sm:max-w-[560px] mx-auto">
                      <span className="flex flex-row  w-auto justify-center gap-2 items-center mt-2 sm:mt-0 min-w-0">
                        {previousData && (
                          <span className="relative flex-shrink-0">
                            <img
                              src={`/profile/${previousData?.gender?.toLowerCase()}-phase-1/${
                                previousData?.level > 6
                                  ? 6
                                  : previousData?.level
                              }.png`}
                              className="min-w-24 max-w-24"
                              alt="User Profile"
                              crossOrigin="anonymous"
                            />
                            {previousData?.loginStreak?.streak >= 90 ? (
                              <img
                                src="/streak/90.png"
                                className="absolute right-0 bottom-6 w-8"
                                alt="Strak"
                                crossOrigin="anonymous"
                              />
                            ) : previousData?.loginStreak?.streak >= 60 ? (
                              <img
                                src="/streak/60.png"
                                className="absolute right-0 bottom-6 w-8"
                                alt="Strak"
                                crossOrigin="anonymous"
                              />
                            ) : previousData?.loginStreak?.streak >= 30 ? (
                              <img
                                src="/streak/30.png"
                                className="absolute right-0 bottom-6 w-8"
                                alt="Strak"
                                crossOrigin="anonymous"
                              />
                            ) : previousData?.loginStreak?.streak >= 14 ? (
                              <img
                                src="/streak/14.png"
                                className="absolute right-0 bottom-6 w-8"
                                alt="Strak"
                                crossOrigin="anonymous"
                              />
                            ) : previousData?.loginStreak?.streak >= 7 ? (
                              <img
                                src="/streak/7.png"
                                className="absolute right-0 bottom-6 w-8"
                                alt="Strak"
                                crossOrigin="anonymous"
                              />
                            ) : null}
                          </span>
                        )}

                        <span class="text-left min-w-0">
                          <h2 className="font-bold text-[18px] min-w-0">
                            {previousData?.name}
                          </h2>
                          <p className="text-[10px] min-w-0">
                            Joined{" "}
                            {previousData
                              ? formatDate(new Date(previousData?.createdAt))
                              : null}
                          </p>
                        </span>
                      </span>

                      <span class="flex-shrink-0 mt-2 sm:mt-0 min-w-0">
                        <h4 className="text-[14px] text-center font-bold min-w-0">
                          # {previousData?.userRank}
                        </h4>
                        <h4 className="text-[12px] text-center font-bold min-w-0">
                          TRUST POINT
                        </h4>
                        <h4 className="text-[16px] text-center font-bold min-w-0">
                          {previousData?.balance}
                        </h4>
                      </span>
                    </div>
                  </>
                </div>
              </div>
            </div>
          )}
        </div>
      )}

      {data && showEligible && (
        <div className="rounded-[16px] bg-[#4A5A69] p-6 items-center relative shadow shadow-white/40 border border-white/10 mb-5">
          <div className="space-y-4">
            <p className="text-lg font-medium">
              To be eligible to claim your FileTrust NFT, please make sure you
              have completed the following tasks:
            </p>

            {countdown && (
              <div className="text-sm text-yellow-400">
                Time remaining (UTC):{" "}
                <span className="text-3xl font-bold">{countdown}</span>
              </div>
            )}

            <ul className="list-disc list-inside text-left text-sm space-y-1">
              <li>more than 2,500 Trust Point</li>
              <li>Follow X</li>
              <li>Join YouTube</li>
              <li>Join Telegram</li>
              <li>Join Discord</li>
            </ul>

            <button
              onClick={handleClaimNFT}
              disabled={loading || data?.hasClaimedNFT}
              className={`mt-4 px-6 py-2 disabled:bg-slate-500 disabled:opacity-80 bg-indigo-500 hover:bg-indigo-600 transition-colors rounded-xl text-white font-semibold shadow-lg`}
            >
              {loading
                ? "Loading..."
                : data?.hasClaimedNFT
                ? "Claimed"
                : "Claim"}
            </button>

            {error && (
              <p className="text-sm text-red-500 mt-2">
                You haven't completed all the required social tasks. Please
                review and complete them on the Tasks page.
              </p>
            )}
          </div>
        </div>
      )}

      <UserCard data={data} />

      <div className="grid grid-cols-6 gap-3 mt-7">
        <span className="col-span-full lg:col-span-4">
          {data && <UserAchivments data={data} getData={getData} />}
        </span>
        <span className="col-span-full lg:col-span-2">
          {data && <Roadmap data={data} />}
        </span>
      </div>
    </div>
  );
};

export default HomePage;
